import { getOpxHostApi } from 'owa-opx';
import type { ScenarioUpdateData } from '../types/ScenarioUpdateData';

type ScenarioDataUpdateListener = (data: ScenarioUpdateData) => void;

const scenarioUpdateListeners = new Set<ScenarioDataUpdateListener>();

/**
 * Initialize scenario-data update listener to get signals from the OPX host app.
 */
export const initializeScenarioUpdateHandler = () => {
    const opxHostApi = getOpxHostApi();

    opxHostApi?.registerScenarioDataUpdatedHandler((data: ScenarioUpdateData) =>
        scenarioUpdateListeners.forEach(listener => listener(data))
    );
};

/**
 * Add new listener onto the listeners list
 * @param listener
 * @returns Unregister function
 */
export const registerScenarioDataListener = (listener: ScenarioDataUpdateListener) => {
    if (!scenarioUpdateListeners.has(listener)) {
        scenarioUpdateListeners.add(listener);
    }

    return () => {
        scenarioUpdateListeners.delete(listener);
    };
};
